import layoutRoutes from '@/router/layout';

const routes = [{
  path: '/',
  component: resolve => require(['@/views/Layout'], resolve),
  children: layoutRoutes,
}, {
  path: '/login',
  name: 'login',
  component: resolve => require(['@/views/Login'], resolve),
  meta: {
    title: 'Login'
  }
}, {
  path: '/reset_password/:token',
  name: 'reset_password_token',
  component: resolve => require(['@/views/ResetPassword'], resolve),
  meta: {
    title: 'Reset Password'
  }
}, {
    path: '/purchase/mobile/:uuid',
    name: 'mobile-order-checkout',
    component: resolve => require(['@/views/MobileCheckout.vue'], resolve),
}, {
    path: '/purchase/mobile/complete/:sessionId',
    name: 'mobile-purchase-complete',
    component: resolve => require(['@/views/MobilePurchaseComplete.vue'], resolve),
}, {
  path: '*',
  component: resolve => require(['../views/404'], resolve),
  meta: {
    title: '404'
  }
}];

export default routes;
